import { motion } from "framer-motion";
import { useState } from "react";
import loader from "../../assets/load.gif";

const ImageWithLoader = ({ src, alt }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="relative w-full h-full flex justify-center align-items-center">
      {!isLoaded && (
        <motion.img
          src={loader}
          alt="Loading..."
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="absolute logo-img load-icon"
        />
      )}
      <motion.img
        src={src}
        alt={alt}
        initial={{ opacity: 0 }}
        animate={{ opacity: isLoaded ? 1 : 0 }}
        transition={{ duration: 0.5 }}
        onLoad={() => {
          setTimeout(()=> setIsLoaded(true), 2000);
        }}
        className=""
      />
    </div>
  );
};

export default ImageWithLoader;
